import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queries } from '@/queries';
import { postFetchGithubData } from '@/services/externalCandidates';

export const useFetchGithubData = (
  id: number,
  mutationProps?: UseMutationOptions<
    Awaited<ReturnType<typeof postFetchGithubData>>
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => postFetchGithubData(id),
    mutationKey: ['fetchGithubData'],
    ...mutationProps,
    onSuccess: (response, variables, context) => {
      mutationProps?.onSuccess?.(response, variables, context);
      queryClient.invalidateQueries(
        queries.externalCandidates.detail(id).queryKey
      );
      queryClient.invalidateQueries(
        queries.externalCandidates.githubRepositories(id).queryKey
      );
    },
  });
};
